import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { BookOpenIcon, BriefcaseIcon, BuildingOfficeIcon, HomeIcon, MagnifyingGlassIcon, MapIcon, UserCircleIcon, ExclamationCircleIcon, Cog8ToothIcon, UserIcon, ChatBubbleOvalLeftEllipsisIcon, ArrowRightOnRectangleIcon, ArrowLeftOnRectangleIcon, ReceiptPercentIcon } from '@heroicons/react/24/outline';
import { useAuth } from '@restworld/feature-authentication';
import { PartnersIcon, RestworldBlackIcon } from '../svg-icons';
import { jsx as _jsx } from "react/jsx-runtime";
var commonProps = {
  className: 'h-5 w-5 text-black',
  'aria-hidden': true
};

var useLoggedInAvatarItems = function useLoggedInAvatarItems() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return useMemo(function () {
    return [{
      key: 'profile',
      label: t('common:go_to_profile'),
      icon: /*#__PURE__*/_jsx(UserIcon, _objectSpread({}, commonProps)),
      url: '/profilo'
    }, {
      key: 'settings',
      label: t('common:settings'),
      icon: /*#__PURE__*/_jsx(Cog8ToothIcon, _objectSpread({}, commonProps)),
      url: '/impostazioni',
      isUnderlined: true
    }, {
      key: 'assistance_desk',
      label: t('common:navigation.assistance_desk'),
      icon: /*#__PURE__*/_jsx(ExclamationCircleIcon, _objectSpread({}, commonProps)),
      url: 'https://help.restworld.it/',
      openOnNewTab: true
    }, {
      key: 'open-intercom',
      label: 'Feedback',
      icon: /*#__PURE__*/_jsx(ChatBubbleOvalLeftEllipsisIcon, _objectSpread({}, commonProps)),
      description: 'opens Intercom widget to let user chat the CS team'
    }, {
      key: 'redirect-to-home',
      label: t('common:return_to_the_home'),
      icon: /*#__PURE__*/_jsx(ArrowLeftOnRectangleIcon, _objectSpread({}, commonProps)),
      description: 'redirects to the home page',
      url: '/?redirected=true'
    }, {
      key: 'logout',
      label: 'Logout',
      icon: /*#__PURE__*/_jsx(ArrowRightOnRectangleIcon, _objectSpread({}, commonProps)),
      isNotVisible: true,
      description: 'Reset the auth status'
    }];
  }, [t]);
};

var useSocialResponsibilityItem = function useSocialResponsibilityItem() {
  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  return useMemo(function () {
    return {
      key: 'social-responsibility',
      label: t('common:navigation.useful_resources'),
      icon: /*#__PURE__*/_jsx(BookOpenIcon, _objectSpread({}, commonProps)),
      subItems: [{
        key: 'contact_us',
        url: '/contatti',
        label: t('common:contact_us'),
        locale: ''
      }, {
        key: 'policy',
        url: '/privacy-policy',
        label: 'Privacy policy',
        locale: ''
      }, {
        key: 'cookie',
        url: '/cookie-policy',
        label: 'Cookie policy',
        locale: ''
      }, {
        key: 'faq',
        url: 'https://help.restworld.it',
        label: 'FAQ'
      }]
    };
  }, [t]);
};

var useEmployerPlatformItem = function useEmployerPlatformItem() {
  var _useTranslation3 = useTranslation(),
      t = _useTranslation3.t;

  return useMemo(function () {
    return {
      key: 'employer-platform',
      label: t('common:who_we_are'),
      icon: /*#__PURE__*/_jsx(RestworldBlackIcon, {}),
      subItems: [{
        key: 'the-team',
        url: '/chi-siamo',
        label: t('common:navigation.the_team'),
        locale: ''
      }, {
        key: 'social',
        url: '/responsabilita-sociale',
        label: t('common:social_responsibility'),
        locale: ''
      }, {
        key: 'work_with_us',
        url: '/lavora-con-noi',
        label: t('common:work_with_us'),
        locale: ''
      }, {
        key: 'become_a_partner',
        url: '/diventa-partner',
        label: t('common:become_a_partner'),
        locale: ''
      }]
    };
  }, [t]);
};

var usePrimaryNavItems = function usePrimaryNavItems() {
  var socialResponsibilityItem = useSocialResponsibilityItem();
  var employerPlatformItem = useEmployerPlatformItem();

  var _useAuth = useAuth(),
      user = _useAuth.user;

  var _useTranslation4 = useTranslation(),
      t = _useTranslation4.t;

  return useMemo(function () {
    return [{
      key: 'worker-platform',
      label: t('common:looking_for_job'),
      icon: /*#__PURE__*/_jsx(MagnifyingGlassIcon, _objectSpread({}, commonProps)),
      subItems: [{
        key: 'looking-for-job',
        url: '/cerco-lavoro',
        label: t('common:work_offers')
      }, {
        key: 'seasonal_jobs',
        url: '/cerco-lavoro/stagionale',
        label: t('common:seasonal_jobs')
      }, {
        key: 'create_your_profile',
        url: '/candidati',
        label: t('common:navigation.create_your_profile'),
        isRecommended: true
      }, {
        key: 'faq',
        url: '/faq',
        label: t('common:frequent_questions'),
        locale: ''
      }, {
        key: 'open-intercom',
        label: t('common:contact_us'),
        description: 'opens Intercom widget to let user chat the CS team'
      }]
    }, employerPlatformItem, socialResponsibilityItem, {
      key: 'who-we-are',
      label: t('common:for_companies'),
      icon: /*#__PURE__*/_jsx(BuildingOfficeIcon, _objectSpread({}, commonProps)),
      subItems: [{
        key: 'appointment',
        url: 'https://www.restworld.it/aziende',
        label: t('common:make_an_appointment'),
        openOnNewTab: true
      }, {
        key: 'employer',
        url: '/employer',
        label: t('common:how_does_it_work'),
        locale: ''
      }]
    }].concat(_toConsumableArray((user === null || user === void 0 ? void 0 : user.type) === 'lead' ? [{
      key: 'settings',
      label: t('common:settings'),
      url: '/impostazioni'
    }] : []));
  }, [employerPlatformItem, socialResponsibilityItem, t, user === null || user === void 0 ? void 0 : user.type]);
};

export var useNavLabelLinks = function useNavLabelLinks() {
  var _useTranslation5 = useTranslation(),
      t = _useTranslation5.t;

  var primaryNavItems = usePrimaryNavItems();
  var loggedInAvatarItems = useLoggedInAvatarItems();
  var socialResponsibilityItem = useSocialResponsibilityItem();
  var employerPlatformItem = useEmployerPlatformItem();
  return useMemo(function () {
    return {
      employerType: {
        primaryNav: [{
          key: 'your_positions',
          label: t('common:your_positions'),
          icon: /*#__PURE__*/_jsx(BriefcaseIcon, _objectSpread({}, commonProps)),
          url: '/employer/job-positions'
        }, {
          key: 'billing',
          label: t('common:billing'),
          icon: /*#__PURE__*/_jsx(ReceiptPercentIcon, _objectSpread({}, commonProps)),
          url: '/employer/fatturazione'
        }, {
          key: 'go_to_the_website',
          label: t('common:go_to_the_website'),
          icon: /*#__PURE__*/_jsx(HomeIcon, _objectSpread({}, commonProps)),
          url: '/'
        }],
        secondaryNav: []
      },
      leadType: {
        primaryNav: primaryNavItems,
        secondaryNav: loggedInAvatarItems.filter(function (item) {
          return item.key !== 'profile';
        })
      },
      ambassadorType: {
        primaryNav: [{
          key: 'location_map',
          url: '/cerco-lavoro',
          label: t('common:location_map'),
          icon: /*#__PURE__*/_jsx(MapIcon, _objectSpread({}, commonProps))
        }, {
          key: 'candidature',
          url: '/challenge-wom/posizioni',
          label: t('common:list_of_positions'),
          icon: /*#__PURE__*/_jsx(BriefcaseIcon, _objectSpread({}, commonProps)),
          locale: ''
        }, {
          key: 'dashboard',
          url: ' /challenge-wom/dashboard',
          label: 'Dashboard',
          icon: /*#__PURE__*/_jsx(HomeIcon, _objectSpread({}, commonProps)),
          locale: ''
        }, socialResponsibilityItem],
        secondaryNav: [{
          key: 'graphic_editor',
          url: 'https://www.canva.com/it_it/scarica',
          label: t('common:graphic_editor'),
          openOnNewTab: true
        }, {
          key: 'chat-gpt',
          url: 'https://chat.openai.com/',
          label: 'Chat GPT',
          openOnNewTab: true
        }, {
          key: 'shorten_link',
          url: 'https://bitly.com/',
          label: t('common:shorten_link'),
          openOnNewTab: true
        }, {
          key: 'community',
          url: 'https://t.me/+e8ebVGuzNEUwODRk',
          label: 'Community (Telegram)',
          openOnNewTab: true
        }, {
          key: 'drive',
          url: 'https://drive.google.com/drive/folders/1uBnUejE5Z0S_GXRqAEuuRneSIOocaXMu',
          label: t('common:useful_materials_google_drive'),
          openOnNewTab: true
        }]
      },
      loggedIn: {
        primaryNav: [{
          key: 'profile',
          label: t('common:profile'),
          icon: /*#__PURE__*/_jsx(UserCircleIcon, _objectSpread({}, commonProps)),
          url: '/profilo'
        }, {
          key: 'explore_map',
          url: '/cerco-lavoro',
          label: t('common:explore_map'),
          icon: /*#__PURE__*/_jsx(MapIcon, _objectSpread({}, commonProps))
        }, {
          key: 'your_applications',
          url: '/candidature',
          label: t('common:your_applications'),
          icon: /*#__PURE__*/_jsx(BriefcaseIcon, _objectSpread({}, commonProps))
        }, {
          key: 'helpful-partners',
          url: '!#',
          label: t('common:helpful_partners'),
          icon: /*#__PURE__*/_jsx(PartnersIcon, {}),
          subItems: [{
            key: 'find_accommodation',
            label: t('common:find_accommodation'),
            url: 'https://housinganywhere.com/it/register/8474',
            openOnNewTab: true
          }, {
            key: 'training',
            label: t('common:training'),
            url: 'https://convivier.com/benvenuti-in-convivier'
          }]
        }, employerPlatformItem, socialResponsibilityItem, {
          key: 'settings',
          label: t('common:settings'),
          url: '/impostazioni'
        }, {
          key: 'assistance',
          label: t('common:assistance'),
          url: 'https://help.restworld.it/',
          openOnNewTab: true
        }, {
          key: 'open-intercom',
          label: t('common:chat_with_us'),
          description: 'opens Intercom widget to let user chat the CS team'
        }],
        secondaryNav: _toConsumableArray(loggedInAvatarItems)
      },
      nonLoggedIn: {
        primaryNav: primaryNavItems,
        secondaryNav: []
      }
    };
  }, [t, employerPlatformItem, loggedInAvatarItems, primaryNavItems, socialResponsibilityItem]);
};